"use strict";
// Copyright © Veeam Software Group GmbH
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportLatestBackupDialog = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("@veeam/components");
const core_1 = require("@veeam/core");
const components_2 = require("../../../components");
const core_2 = require("../../../core");
const ExportLatestBackupInteractor_1 = require("./ExportLatestBackupInteractor");
require("./types");
const ExportLatestBackupDialog = ({ isLoading, onDeactivate, onDone, onCancel, onClose, texts, }) => {
    const { t } = core_2.useFeatureContext();
    const { interactor } = core_1.useInteractor(() => {
        const listeners = {
            onDeactivate,
            onDone,
            onCancel,
            onClose,
        };
        const errorTexts = {
            passwordNotEqual: t('exportLatestBackupDialog|form|fields|password|errors|passwordNotEqual'),
        };
        return new ExportLatestBackupInteractor_1.ExportLatestBackupInteractor(listeners, errorTexts);
    });
    return (react_1.default.createElement(components_1.Dialog, { id: "exportLatestBackupDialog", header: (texts === null || texts === void 0 ? void 0 : texts.header) || t('exportLatestBackupDialog|header'), title: (texts === null || texts === void 0 ? void 0 : texts.title) || t('exportLatestBackupDialog|title'), size: {
            width: components_1.DIALOG_SIZE.xs,
            height: components_1.DIALOG_SIZE.auto,
        }, onRequestClose: () => {
            interactor.onClose();
        }, loading: isLoading, actions: [
            {
                view: components_1.ACTION_VIEW.primary,
                text: (texts === null || texts === void 0 ? void 0 : texts.buttonDone) || t('exportLatestBackupDialog|actions|done|label'),
                onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                    yield interactor.onDone();
                }),
            },
            {
                view: components_1.ACTION_VIEW.secondary,
                text: (texts === null || texts === void 0 ? void 0 : texts.buttonCancel) || t('exportLatestBackupDialog|actions|cancel|label'),
                onClick: () => {
                    interactor.onCancel();
                },
            },
        ] },
        react_1.default.createElement(components_2.PreventAutoFillPassword, null),
        react_1.default.createElement(components_1.FormLayout, { inlineLabel: true },
            react_1.default.createElement(components_1.PasswordField, { label: (texts === null || texts === void 0 ? void 0 : texts.passwordLabel) || t('exportLatestBackupDialog|form|fields|password|label'), field: interactor.form.fields.password }),
            react_1.default.createElement(components_1.PasswordField, { label: (texts === null || texts === void 0 ? void 0 : texts.repeatPasswordLabel) ||
                    t('exportLatestBackupDialog|form|fields|repeatPassword|label'), field: interactor.form.fields.repeatPassword }),
            react_1.default.createElement(components_1.TextField, { label: (texts === null || texts === void 0 ? void 0 : texts.passwordHintLabel) || t('exportLatestBackupDialog|form|fields|passwordHint|label'), field: interactor.form.fields.hint }))));
};
exports.ExportLatestBackupDialog = ExportLatestBackupDialog;
//# sourceMappingURL=ExportLatestBackupDialog.js.map